import Api from "../../api";

import { VictimState, SERVICE_ID } from "./models.jsx";
import { Reply } from "../base/models.jsx";

const liveUrl = "live";
const repliesUrl = "replies";
const requestsUrl = "requests";

class VictimsApi extends Api {
	
	get(callback) {
		var url = this.baseUrl + "/" + liveUrl;

		this.client.get(url)
			.then((response) => {
				var data = [];
				for (var index = 0; index < response.data.length; index++) {
					data.push(new VictimState(response.data[index]));
				}

				callback({
					result: data,
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

}

class ReplyApi extends Api {
	
	create(alertId, replyData, callback) {

		let reply = new Reply();
		reply.creation();

		reply.requestId = alertId;
		reply.code = replyData.code;
		reply.serviceId = SERVICE_ID;

	    let url = this.baseUrl + "/" + requestsUrl + "/" + alertId + "/" + repliesUrl ;

		this.client.post(url, reply)
			.then((response) => {
				callback({
					result: new Reply(response.data.reply),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

}

class EmergencyServiceApi{

	constructor(baseUrl) {
		this.victims = new VictimsApi(baseUrl);
		this.replies = new ReplyApi(baseUrl);
	}

}


export default EmergencyServiceApi;